import { useTranslation } from "react-i18next";
import "../../../styles/UserAuthPage.css";
import { CONTACT_EMAIL, FACEBOOK_URL, LINKEDIN_URL, YOUTUBE_URL } from "../../../constants/links";

function Socials() {
  const { t } = useTranslation();

  return (
    <>
      <p className="authPage__socialTitle">{t("auth.socialsTitle")}</p>

      <div className="authPage__socials">
        {/* EMAIL */}
        <a
          className="authPage__socialLink authPage__socialLink--gmail"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Email"
          href={`mailto:${CONTACT_EMAIL}`}
          onClick={(e) => {
            window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${CONTACT_EMAIL}`);
            e.preventDefault();
          }}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#EA4335" d="M1.5 4.5v15h21v-15l-10.5 8z" />
            <path fill="#FBBC04" d="M22.5 4.5H1.5L12 12.5z" />
            <path fill="#34A853" d="M1.5 19.5l7.5-7" />
            <path fill="#4285F4" d="M22.5 19.5l-7.5-7" />
          </svg>
        </a>

        {/* LINKEDIN */}
        <a
          href={LINKEDIN_URL}
          className="authPage__socialLink authPage__socialLink--linkedin"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="#0A66C2"
              d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.03-1.84-3.03-1.84 0-2.12 1.44-2.12 2.93v5.67H9.37V9h3.42v1.56h.05c.48-.9 1.63-1.84 3.35-1.84 3.58 0 4.24 2.35 4.24 5.41v6.32zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45z"
            />
          </svg>
        </a>

        {/* YOUTUBE */}
        <a
          href={YOUTUBE_URL}
          className="authPage__socialLink authPage__socialLink--youtube"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="#FF0000"
              d="M23.5 6.2s-.2-1.7-.9-2.4c-.9-.9-1.9-.9-2.4-1C16.8 2.5 12 2.5 12 2.5h0s-4.8 0-8.2.3c-.5.1-1.5.1-2.4 1C.7 4.5.5 6.2.5 6.2S.2 8.1.2 10v1.8c0 1.9.3 3.8.3 3.8s.2 1.7.9 2.4c.9.9 2.1.9 2.6 1 1.9.2 8 .3 8 .3s4.8 0 8.2-.3c.5-.1 1.5-.1 2.4-1 .7-.7.9-2.4.9-2.4s.3-1.9.3-3.8V10c0-1.9-.3-3.8-.3-3.8z"
            />
            <path fill="#fff" d="M9.75 15.02L15.98 11.5 9.75 7.98z" />
          </svg>
        </a>

        {/* FACEBOOK */}
        <a
          href={FACEBOOK_URL}
          className="authPage__socialLink authPage__socialLink--facebook"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="#1877F2"
              d="M24 12a12 12 0 1 0-13.88 11.85v-8.39H7.08V12h3.04V9.41c0-3 1.79-4.66 4.52-4.66 1.31 0 2.68.23 2.68.23v2.95h-1.51c-1.49 0-1.95.93-1.95 1.88V12h3.32l-.53 3.46h-2.79v8.39A12 12 0 0 0 24 12z"
            />
          </svg>
        </a>
      </div>
    </>
  );
}

export default Socials;
